import * as React from 'react';
import { ModalWindow, UIText1 } from '@cian/ui-kit';
import { onlinePurchase } from '../../settings';

import { PurchaseList } from './components/PurchaseList';
import { PurchaseLayout } from './components/PurchaseLayout';
import { IPurchase } from '../../types/purchase';

export function PurchaseContainer() {
  const [open, setOpen] = React.useState(false);
  const [content, setContent] = React.useState(onlinePurchase.algorithm[0]);

  const openModal = (item: IPurchase) => {
    setContent(item);
    setOpen(true);
  };
  const closeModal = () => setOpen(false);

  return (
    <>
      <PurchaseLayout
        title={onlinePurchase.title}
        list={<PurchaseList list={onlinePurchase.algorithm} onOpenModal={openModal} />}
      />

      <ModalWindow
        open={open}
        fixed={false}
        maxWidth={472}
        outside={true}
        onClose={closeModal}
        title={content.title}
        content={<UIText1>{content.text}</UIText1>}
      />
    </>
  );
}
